import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GestaoAgendamentosComponent } from './gestao-agendamentos/gestao-agendamentos.component';

@NgModule({
  declarations: [GestaoAgendamentosComponent],
  imports: [
    CommonModule
  ],
  exports: [
    GestaoAgendamentosComponent
  ]
})
export class GestaoAgendamentoModule { }
